import { DFPModal } from "@/components/modals/dfp-modal";
import type { OrganizationAssetType } from "@/models/organization/dashboard-analytics/dashboard-analytics.model";
import type { ServiceChannelAssetType } from "@/services/service-channel-service";
import { Col, Form, Row, Select, Spin, Typography } from "antd";

interface Props {
	open: boolean;
	onClose: () => void;
	assetTypes: OrganizationAssetType[];
	scAssetTypes: ServiceChannelAssetType[];
	mappings: Record<number, string | number>;
	onChange: (id: number, value: string | number) => void;
	onSave: () => void;
	saving: boolean;
	loading?: boolean;
}

/**
 * Modal component for mapping FacilityAI asset types to Service Channel asset types
 */
export const AssetMappingModal = ({
	open,
	onClose,
	assetTypes,
	scAssetTypes,
	mappings,
	onChange,
	onSave,
	saving,
	loading = false,
}: Props) => {
	return (
		<DFPModal
			open={open}
			title="Asset Type Mapping"
			onOk={onSave}
			onCancel={onClose}
			confirmLoading={saving}
			width={800}
		>
			{/* Column headers */}
			<Row gutter={16} style={{ marginBottom: 8 }}>
				<Col span={12}>
					<Typography.Text strong>FacilityAI Asset Types</Typography.Text>
				</Col>
				<Col span={12}>
					<Typography.Text strong>Service Channel Asset Types</Typography.Text>
				</Col>
			</Row>

			{/* Scrollable mapping form */}
			<div
				style={{
					height: "500px",
					overflowY: "auto",
					padding: "0 16px",
				}}
			>
				<Spin spinning={loading} size="large">
					<Form layout="vertical">
						{assetTypes.map((type) => (
							<Row key={type.id} gutter={16} style={{ marginBottom: 8 }}>
								<Col span={12}>{type.name}</Col>
								<Col span={12}>
									<Select
										showSearch
										optionFilterProp="label"
										filterOption={(input, option) =>
											String(option?.label ?? "")
												.toLowerCase()
												.includes(input.toLowerCase())
										}
										placeholder="Select type"
										value={mappings[type.id]}
										onChange={(v) => onChange(type.id, v)}
										options={scAssetTypes.map((s) => ({
											value: s.id,
											label: s.name,
										}))}
										style={{ width: "100%" }}
									/>
								</Col>
							</Row>
						))}
					</Form>
				</Spin>
			</div>
		</DFPModal>
	);
};
